/* eslint-disable react-hooks/exhaustive-deps */
import { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState } from "react"
import {
  Box,
  IconButton,
  Paper,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Formater, TypeRecords } from "src/framework/commons/Formater"
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList"
import theme from "src/theme/light"

import stringAvatarImg from '../../../assets/string.png'
import microinversorAvatarImg from '../../../assets/microinversor.png'
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade"
import { useHistory } from "react-router-dom"
import { ListagemItem, InversorModuloResponse, ModuloListagem, ModuloPorRegiaoListagemResponse, Projeto, Option } from "src/components/projetos/types"
import { formState$, modalComponentesDetalhesData$ } from "src/store/vendas/projetos/store"
import { setPersonalizadoTabDisabledStatus } from "src/store/vendas/projetos/actions"
import { Layout } from "src/components/projetos/_layouts"
import { redirecionarParaProjetoVertical } from "src/components/projetos/utils/redirecionarParaProjetoVertical"
import { resetarProjeto } from "src/components/projetos/utils/resetarProjeto"
import { ModalType, checarPotenciaTotal } from "src/components/projetos/utils/checarPotenciaTotal"
import { POTENCIA_MINIMA_ENGENHARIA, NUM_MINIMO_INVERSORES, MODULO_POTENCIA_MAXIMA_ATTR, TIPOS_INVERSOR_OPTIONS, INVERTER_MAX_POWER_ATTR, INVERTER_MAX_POWER_INPUT_ATTR, MODULO_POWER_ATTR, MODULO_POTENCIA_MINIMA_ATTR, NOVO_PROJETO_ENGENHARIA } from "src/components/projetos/constants"
import { checarNumeroMaximoDeInversores } from "src/components/projetos/utils/checarNumeroMaximoDeInversores"
import { ComponenteProvider } from "src/providers/estoque/ComponenteProvider"
import { potenciaTotalMaiorQuePotenciaMaxima } from "src/components/projetos/utils/potenciaTotalMaiorQuePotenciaMaxima"
import { checarParametroRegiaoPotencia } from "src/components/projetos/utils/checarParametroRegiaoPotencia"
import { potenciaTotalMenorQuePotenciaMinima } from "src/components/projetos/utils/potenciaTotalMenorQuePotenciaMinima"
import { ALERT_BLOCK_INVERTERS, ALERT_MAX_INVERTERS, ALERT_MIN_INVERTERS, ALERT_MIN_MODULES, ALERT_MOSTRAR_PARAMETRO_REGIAO_POTENCIA, ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA, ALERT_POPUP_PARCEIRO, alertsList$, clearIntervalAlerts, setAlertsList, startIntervalAlerts, TAlertsDom } from "src/framework/store/ProcessarFilaMensagensStore"
import { FindInPageOutlined } from "@mui/icons-material"
import ModulosListMobile from "src/components/projetos/containers/Mobile/ModulosListMobile"
import InversoresListMobile from "src/components/projetos/containers/Mobile/InversoresListMobile"
import { ID_INVERSOR, ID_MICROINVERSOR } from "src/components/componentes/types";

const useStyles = makeStyles({
  quantityHelperText: {
    color:  theme.palette.error.main,
    display: 'block',
    textAlign: 'left',
    marginLeft: 25,
  },
  warningText: {
    color: theme.palette.warning.main,
    fontWeight: 600,
  },
  moduleTitle: {
    fontWeight: 600,
  },
  radioButton: {
    marginRight: 14,
  }
})

const tiposInversoresMap = new Map<string, number>([
  ['string', ID_INVERSOR],
  ['microinversor', ID_MICROINVERSOR]
])

interface GeradorProps {
  onClickBack: () => void
  onClickNext: () => void
  formState: Projeto;
  onChangeFormState: Dispatch<SetStateAction<Projeto>>
}

const componenteProvider = new ComponenteProvider()
const buscarInversores = async (moduloId: number, inversores: ListagemItem[] = [], filters: { regiao_id?: number[]; potenciaEmWatts?: number; segmento?: string } = {}) => {
  if (moduloId) {
    const items = await componenteProvider.buscarInversoresPorModuloId(moduloId, filters)
    if(!items.length) return []

    const result: ListagemItem[] = items.map((inversor: InversorModuloResponse): ListagemItem => {
      const potencia = inversor.atributos.find(item => item.atributo === INVERTER_MAX_POWER_ATTR)
      const potenciaMaximaEntradaCC = inversor.atributos.find(item => item.atributo === INVERTER_MAX_POWER_INPUT_ATTR)
      const savedItem = inversores.find(item => item.componente_id === inversor.id)

      return {
        potenciaMaximaEntradaCC: Number(potenciaMaximaEntradaCC?.valor || 0),
        componente_id: inversor.id,
        nome: inversor.nome,
        modelo: inversor?.modelo,
        descricao: inversor.descricao,
        quantidade: savedItem?.quantidade || 0,
        altura: inversor.altura,
        largura: inversor.largura,
        peso: inversor.peso,
        valor: 0,
        categoria_componentes_id: inversor.categoria_componentes_id,
        potencia: Number(potencia?.valor || 0),
        valor_unitario: savedItem?.valor_unitario || 0,
        exibir_popup_parceiro: inversor?.exibir_popup_parceiro,
      }
    })
    return result;
  }
}

const openItensAlert = (status: boolean, type?: ModalType): string | null => {
  if (status) {
    if (type === 'min-inverters') return ALERT_MIN_INVERTERS;
    if (type === 'min-modulos') return ALERT_MIN_MODULES;
  }

  return null;
}

let timerBuscarInversores: NodeJS.Timeout

const Gerador = ({ onClickNext, onClickBack, formState, onChangeFormState }: GeradorProps) => {
  const history = useHistory()
  const classes = useStyles()

  const [alterouInversor, setAlterouInversor] = useState<boolean | any>(false)
  const [tipoInversor, setTipoInversor] = useState<Option<number> | null>(formState.tipo_inversor ||null)
  const [modulosList, setModulosList] = useState<ModuloListagem[]>([])

  const [inversoresListAuxiliar, setInversoresListAuxiliar] = useState<ListagemItem[]>([])
  const [inversoresList, setInversoresList] = useState<ListagemItem[]>([])

  const [fraseParceiroExibidoList] = useState<number[]>([]);

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const setFormState = useCallback((newState: Partial<Projeto>)=>{
    onChangeFormState(old => ({ ...old, ...newState }))
  },[onChangeFormState])

  const showMaxPowerNotify = useCallback(() => {
    const state = { ...formState }
    redirecionarParaProjetoVertical({
      onNegation: () => {
        formState$.next({...resetarProjeto(state), ...NOVO_PROJETO_ENGENHARIA })
        history.push('/projetos/verticais/novo',{ allowAccess: true })
      },
      yesText: 'Continuar personalizando'
    })
  },[history, formState])

  useEffect(()=>{
    if (tipoInversor) {
      const inversores = inversoresListAuxiliar.filter(item => item.categoria_componentes_id === tipoInversor.value)
      const sortedInverters = inversores.sort((a, b) => a.potencia - b.potencia);
      setInversoresList(sortedInverters)
      setFormState({ inversoresList: sortedInverters || [] })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[inversoresListAuxiliar, tipoInversor])

  useEffect(()=>{
    setFormState({ alterou_inversor: alterouInversor })
  },[alterouInversor, setFormState])

  const selectedModulo = useMemo(()=>{
    return modulosList.find(item => item.selecionado)
  },[modulosList])

  const listarInversores = useCallback((state: Projeto) => {
    clearTimeout(timerBuscarInversores)
    timerBuscarInversores = setTimeout(() => {
      const moduloSelecionado = state.modulosList?.find(item => item.selecionado)
      if (!moduloSelecionado) return;
      const potenciaTotalInWatts = moduloSelecionado.quantidade * moduloSelecionado.potencia
      const regioesIds = state.regioes.map(item => item.id)
      buscarInversores(moduloSelecionado.componente_id, state.inversoresList, { potenciaEmWatts: potenciaTotalInWatts, regiao_id: regioesIds, segmento: formState.segmento?.includes("on") ? "on" : "off" }).then(result => {
        setInversoresListAuxiliar(result || [])
      })
    }, 300)
  },[]);

  useEffect(()=>{
    const carregarDadosIniciais = async () => {
      
      const currentRegioes = formState.regioes || []
      if (!currentRegioes.length) return;
      setTipoInversor(formState.tipo_inversor)
      componenteProvider.buscarModulosPorRegiao(currentRegioes.map((item: any) => item.id), undefined, 'personalizado', undefined, undefined, undefined, formState.segmento?.includes("on") ? "on" : "off").then((res) => {
        if(res.length) {
          const items: ModuloPorRegiaoListagemResponse[] = res || []

          const result = items.map((modulo: ModuloPorRegiaoListagemResponse) => {
            const potencia = modulo.atributos.find(item => item.atributo === MODULO_POWER_ATTR)
            const savedItem = formState.modulosList ? formState.modulosList.find(item => item.componente_id === modulo.id) : null

            listarInversores(formState)

            const hasMicroInversores = modulo.inversores.some((inversor) => inversor.categoria_componentes_id === ID_MICROINVERSOR)
            const hasInversor = modulo.inversores.some((inversor) => inversor.categoria_componentes_id === ID_INVERSOR)

            const inversoresTipos = []
            if (hasMicroInversores) inversoresTipos.push('microinversor')
            if (hasInversor) inversoresTipos.push('string')

            const potenciaMaxima = modulo.atributos.find(item => item.atributo === MODULO_POTENCIA_MAXIMA_ATTR)
            const potenciaMinima = modulo.atributos.find(item => item.atributo === MODULO_POTENCIA_MINIMA_ATTR)

            return {
              potenciaMaxima: Number(potenciaMaxima?.valor || 0),
              potenciaMinima: Number(potenciaMinima?.valor || 0),
              componente_id: modulo.id,
              inversoresTipos: inversoresTipos,
              categoria_componentes_id: modulo.categoria_componentes_id,
              potencia: Number(potencia?.valor || 0),
              faturamento: modulo.data_previsao_faturamento ? new Date(modulo.data_previsao_faturamento).toISOString() : undefined,
              nome: modulo.nome,
              descricao: modulo.descricao,
              quantidade: savedItem?.quantidade || 0,
              selecionado: savedItem?.selecionado || false,
              categoria: modulo.categoria_componentes_nome,
              altura: modulo.altura,
              largura: modulo.largura,
              peso: modulo.peso,
              valor: 0, // Calculado no backend
              comprimento: modulo.comprimento,
              valor_unitario: savedItem?.valor_unitario || 0,
              regioes_parametros: modulo?.regioes_parametros,
              exibir_popup_parceiro: modulo?.exibir_popup_parceiro,
            }
          })
          setModulosList(result)
          setFormState({ modulosList: result })
        }

        // iniciando intervalo de mensagens
        clearIntervalAlerts();
        startIntervalAlerts();
      })
    }

    carregarDadosIniciais();
  },[formState.regioes])

  const isGreatherThanPowerLimitForCustomProjects = useCallback(()=>{
    const pot = selectedModulo?.potencia || 0
    const numModulos = selectedModulo?.quantidade || 0
    const powerInKw = (pot * numModulos) / 1000
    return powerInKw > POTENCIA_MINIMA_ENGENHARIA
  },[selectedModulo])

  const checarSePotenciaTotalMaiorQuePotenciaMaxima = useCallback(( moduloSelecionado: ModuloListagem | null = selectedModulo || null ): { status: boolean; potenciaMaxima: number; } =>{
    return potenciaTotalMaiorQuePotenciaMaxima(moduloSelecionado)
  },[selectedModulo])
  const checarSePotenciaTotalMenorQuePotenciaMinima = useCallback(( moduloSelecionado: ModuloListagem | null = selectedModulo || null ): { status: boolean; potenciaMinima: number; } =>{
    return potenciaTotalMenorQuePotenciaMinima(moduloSelecionado)
  },[selectedModulo])
  const checarPotenciaTotalEstaNoRangePotenciaRegiao = useCallback(( moduloSelecionado: ModuloListagem | null = selectedModulo || null ): { status: boolean; parametro: any; } =>{
    return checarParametroRegiaoPotencia(moduloSelecionado)
  },[selectedModulo])
  
  const checkTotalPowerIsInvalid = useCallback((): { status: boolean, type?: ModalType } => {
    if (!selectedModulo) return { status: false }
    return checarPotenciaTotal(selectedModulo, inversoresList)
  },[inversoresList, selectedModulo])

  const handleChangeModuleQuantity = useCallback((id: number, value: string)=> {
    const quantidade = Number(value || 0);
    let _alertasList: TAlertsDom[] = alertsList$.getValue();

    const state = { ...formState }
        const newModulosList = modulosList.map((item) => {
      if (item.componente_id === id) {
        if(item.exibir_popup_parceiro && formState.isEdit) {
          const idx = fraseParceiroExibidoList.findIndex(c => c === id);
          if(idx < 0 && quantidade > 0) {
            fraseParceiroExibidoList.push(id);
            _alertasList.push({
              alert: ALERT_POPUP_PARCEIRO,
            });
          } else {
            if(quantidade === 0) {
              fraseParceiroExibidoList.splice(idx, 1);
            }
          }
        }
        item.quantidade = Number(value || 0)
      }
      return item
    })
    
    state.modulosList = newModulosList
    setFormState(state)
    setModulosList(newModulosList)

    // Verifica se o projeto ultrapassa o limite de potência
    const canBeVertical = isGreatherThanPowerLimitForCustomProjects()

    if (canBeVertical) {
      showMaxPowerNotify()
      return;
    }

    // Verifica parâmetros de potência configurada
    const novoModuloSelecionado = newModulosList?.find(item => item?.componente_id === id);
    if (novoModuloSelecionado?.regioes_parametros?.length) {
      const { status, parametro } = checarParametroRegiaoPotencia(novoModuloSelecionado);
      if (!status) {
        _alertasList.push({
          alert: ALERT_MOSTRAR_PARAMETRO_REGIAO_POTENCIA,
          data: {
            potencia_inicial: parametro?.potencia_inicial,
            potencia_final: parametro?.potencia_final,
          }
        });
        setAlertsList(_alertasList);
        return;
      }
    } else {
      const { status: potenciaInvalida, potenciaMaxima } = checarSePotenciaTotalMaiorQuePotenciaMaxima();
      const { status: potenciaMinimaInvalida, potenciaMinima } = checarSePotenciaTotalMenorQuePotenciaMinima();

      if (potenciaInvalida){
        _alertasList.push({
          alert: ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA,
          data: {
            potencia_maxima: potenciaMaxima,
          }
        });
        setAlertsList(_alertasList);
        return;
      } 
      if (potenciaMinimaInvalida){
        _alertasList.push({
          alert: ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA,
          data: {
            potencia_minima: potenciaMinima,
          }
        });
        return;
      } 
    }

    // Verifica limites de potência
    const { status, type } = checkTotalPowerIsInvalid();
    const alerta = openItensAlert(status, type);
    if(alerta) {
      _alertasList.push({
        alert: alerta
      });
    }

    if(_alertasList && _alertasList.length) {
      setAlertsList(_alertasList);
    }

    listarInversores(state)
  },[checarSePotenciaTotalMaiorQuePotenciaMaxima, checarSePotenciaTotalMenorQuePotenciaMinima, listarInversores, formState, isGreatherThanPowerLimitForCustomProjects, showMaxPowerNotify, checkTotalPowerIsInvalid, modulosList, setFormState])

  const checkInverterQuantityIsInvalid = useCallback((id: number)=>{
    if (formState?.tipo_inversor?.value === ID_MICROINVERSOR) return false;
    return checarNumeroMaximoDeInversores(inversoresList, id)
  },[inversoresList, formState?.tipo_inversor?.value])

  const checkAddedInvertersQuantityIsInvalid = useCallback(() => {
    if (formState?.tipo_inversor?.value === ID_MICROINVERSOR) return false;
    return checarNumeroMaximoDeInversores(inversoresList)
  },[inversoresList, formState?.tipo_inversor?.value])

  const handleChangeInverterQuantity = useCallback((id: number, value: string)=> {
    let _alertasList: TAlertsDom[] = alertsList$.getValue();
    const state = { ...formState }
    const quantidade = Number(value || 0);
    let newInversoresList = inversoresList.map((item) => {
      if (item.componente_id === id) {
        item.quantidade = quantidade
      }
      return item
    })

    const selected = newInversoresList.find(item => item.componente_id === id);

    if(selected?.exibir_popup_parceiro) {
      const idx = fraseParceiroExibidoList.findIndex(c => c === id);
      if(idx < 0 && quantidade > 0) {
        _alertasList.push({
          alert: ALERT_POPUP_PARCEIRO
        });
        fraseParceiroExibidoList.push(id);
      } else {
        if(quantidade === 0) {
          fraseParceiroExibidoList.splice(idx, 1);
        }
      }
    }

    let temEGT = false;
    let temIONS = false;
    // Verifica se o modelo do inversores possui EGT e IONS 
    newInversoresList?.filter(i => i.quantidade > 0)?.forEach(inversor => {
      const modelo = inversor?.modelo || '';
      if (modelo?.includes("EGT")) temEGT = true;
      else if (modelo?.includes("IONS")) temIONS = true;
    });
    if (temEGT && temIONS) {
      _alertasList.push({
        alert: ALERT_BLOCK_INVERTERS
      });

      newInversoresList = newInversoresList?.map(item => item.componente_id !== id ? {...item, quantidade: 0} : item);
    }

    state.inversoresList = newInversoresList
    setFormState(state)
    setInversoresList(newInversoresList)

    // Verifica se a quantidade de inversores não ultrapassa o limite
    const isInvalidQuantityMax = checkInverterQuantityIsInvalid(id);
    if (isInvalidQuantityMax) {
      _alertasList.push({
        alert: ALERT_MAX_INVERTERS
      });
    } else {
      //verifica total de potência  
      const { status, type } = checkTotalPowerIsInvalid();
      if (status) {
        const alerta = openItensAlert(status, type);
        if(alerta) {
          _alertasList.push({
            alert: alerta
          });
        }
      }
    }

    if(_alertasList && _alertasList.length) {
      setAlertsList(_alertasList);
    }

  },[formState, checkTotalPowerIsInvalid, checkInverterQuantityIsInvalid, inversoresList, setFormState])
  
  const handleSelect = useCallback((id: number) => {
    let _alertasList: TAlertsDom[] = alertsList$.getValue();
    const currentSelected = modulosList.find(item => item.selecionado)
    if (currentSelected?.componente_id === id) return;
    setInversoresList([])
    setTipoInversor(null)
    const state = { ...formState }
    let moduloSelecionado: ModuloListagem | null = null

    const newModulosList = modulosList.map((item) => {
      if (item.componente_id === id) {
        item.selecionado = true
        moduloSelecionado = item;
      } else {
        item.selecionado = false
      }
      return item
    });

    const currentSelectedNew = modulosList.find(item => item.selecionado);

    if(currentSelectedNew?.exibir_popup_parceiro) {
      _alertasList.push({
        alert: ALERT_POPUP_PARCEIRO,
      });
    }

    state.modulosList = newModulosList
    setFormState({...state, estruturasSelecionadas: []})
    setModulosList(newModulosList)
    listarInversores(state)

    // Verifica parâmetros de potência configurada
    const novoModuloSelecionado = newModulosList?.find(item => item?.componente_id === id);
    if (novoModuloSelecionado?.regioes_parametros?.length) {
      const { status, parametro } = checarParametroRegiaoPotencia(novoModuloSelecionado);
      if (!status) {
        _alertasList.push({
          alert: ALERT_MOSTRAR_PARAMETRO_REGIAO_POTENCIA,
          data: {
            potencia_inicial: parametro?.potencia_inicial,
            potencia_final: parametro?.potencia_final,
          }
        });
        setAlertsList(_alertasList);
        return;
      }
    } else {
      const { status, potenciaMaxima } = potenciaTotalMaiorQuePotenciaMaxima(moduloSelecionado)
      if (status) {
        _alertasList.push({
          alert: ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA,
          data: {
            potencia_maxima: potenciaMaxima,
          }
        });
      }
  
      const { status: statusPotenciaMinima, potenciaMinima } = potenciaTotalMenorQuePotenciaMinima(moduloSelecionado)
      if (statusPotenciaMinima) {
        _alertasList.push({
          alert: ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA,
          data: {
            potencia_minima: potenciaMinima,
          }
        });
      }
      if(_alertasList && _alertasList.length) {
        setAlertsList(_alertasList);
      }
    }
  },[listarInversores, formState, modulosList, setFormState])

  const potenciaTotal = useMemo<number>(() => {
    const moduloSelecionado = formState.modulosList?.find(item => item.selecionado);
    const potencia = moduloSelecionado?.potencia || 0;
    const quantidade = moduloSelecionado?.quantidade || 1;
    return Number((potencia / 1000.0 * quantidade).toFixed(2));
  },[formState?.modulosList]);

  const potenciaInvalida = useMemo<boolean>(() => {
    return potenciaTotal > POTENCIA_MINIMA_ENGENHARIA;
  },[potenciaTotal]);

  const nextButtonIsDisabled = useMemo(()=>{
    const selectedModulo = modulosList.find(item => item.selecionado)
    const invertersTotal = inversoresList.reduce((acc,curr) => acc + curr.quantidade, 0)
    if (!tipoInversor?.value) return true;
    if (!selectedModulo || selectedModulo?.quantidade === 0) return true;
    if (checkAddedInvertersQuantityIsInvalid()) return true;
    if (selectedModulo?.regioes_parametros?.length) {
      if (checarPotenciaTotalEstaNoRangePotenciaRegiao().status === false) return true;
    } else {
      if (checarSePotenciaTotalMaiorQuePotenciaMaxima().status) return true;
      if (checarSePotenciaTotalMenorQuePotenciaMinima().status) return true;
    }
    if (checkTotalPowerIsInvalid().status) return true;
    if (isGreatherThanPowerLimitForCustomProjects()) return true;
    if (selectedModulo?.quantidade < NUM_MINIMO_INVERSORES) return true;
    if (invertersTotal === 0) return true;
    if (potenciaInvalida) return true;
    return false;
  },[checarSePotenciaTotalMaiorQuePotenciaMaxima, checarSePotenciaTotalMenorQuePotenciaMinima, checarPotenciaTotalEstaNoRangePotenciaRegiao, isGreatherThanPowerLimitForCustomProjects, modulosList, tipoInversor, inversoresList, checkTotalPowerIsInvalid, checkAddedInvertersQuantityIsInvalid, potenciaInvalida])

  useEffect(()=>{
    setPersonalizadoTabDisabledStatus('estruturas', nextButtonIsDisabled)
  },[nextButtonIsDisabled])

  const renderModulos = useCallback(() => {
    if (isMobile) {
      return (
        <ModulosListMobile 
          modulosList={modulosList || []}
          handleSelect={handleSelect}
          handleChangeModuleQuantity={handleChangeModuleQuantity}
          stringAvatarImg={stringAvatarImg}
          microinversorAvatarImg={microinversorAvatarImg}
          titulo="* Módulos"
          helperText="Mínimo 2."
        />
      )
    }

    return (
      <TableContainer component={Paper}>
        <Table aria-label="listagem de modulos disponíveis">
          <TableHead>
            <TableRow>
              <TableCell align='left'><strong>Módulos</strong></TableCell>
              <TableCell align='right'><strong>Inversores disponíveis</strong></TableCell>
              <TableCell align='center'><strong>Quantidade</strong></TableCell>
              <TableCell align='center'><strong>Dados Técnicos</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {modulosList.map((row) => (
              <TableRow key={row.componente_id}>
                <TableCell style={{ maxWidth: '400px' }} align='right' component="th">
                  <Box display='flex'>
                    <Radio className={classes.radioButton} value={row.componente_id} checked={row.selecionado} onClick={() => handleSelect(row.componente_id)} />
                  
                    <Box textAlign={'left'}>
                      <Typography className={classes.moduleTitle} variant='body1' color='textPrimary'>
                        {row.nome}
                      </Typography>
                      {row.descricao && (
                        <Typography variant='body2' color='textSecondary'>
                        <span className={classes.warningText}>Atenção</span>: {row.descricao}
                        </Typography>
                      )}
                      {row.faturamento && (
                        <Typography variant='body2' color='textSecondary'>
                          Previsão de faturamento: {Formater.toString(row.faturamento, TypeRecords.DATE)}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  
                </TableCell>
                <TableCell align='right' component="th">
                  {row.inversoresTipos.includes('string') && (
                    <Tooltip title='String'>
                      <img src={stringAvatarImg} alt='example'/>
                    </Tooltip>
                  )}
                  {row.inversoresTipos.includes('microinversor') && (
                    <Tooltip title='Microinversor'>
                      <img src={microinversorAvatarImg} alt='example'/>
                    </Tooltip>
                  )}
                </TableCell>
                <TableCell align='center' component="th">
                  {row.selecionado && (
                    <Box width="180px" margin={"0 auto"}>
                      <InputQuantidade value={row.quantidade} onChange={(v: any) => handleChangeModuleQuantity(row.componente_id, v)} />
                      <small className={classes.quantityHelperText}>Mínimo 2.</small>
                    </Box>
                  )}
                </TableCell>
                <TableCell align='center' component="th">
                  <Box display={"flex"} alignItems="center" justifyContent={"center"}>
                    <IconButton
                      onClick={() => row.componente_id && modalComponentesDetalhesData$.next(row.componente_id)}
                      size="large">
                        <FindInPageOutlined htmlColor="black" />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }, [classes, handleSelect, handleChangeModuleQuantity, modulosList])

  const renderInversores = useCallback(()=>{
    if (!selectedModulo || !inversoresList.length) return null

    return (
      <Box mt={isMobile ? 0 : 4}>
        <Typography align="left" variant="body2" style={isMobile ? {marginTop: 3, marginBottom: 15} : {}}>
          <strong style={isMobile ? {padding: 4, fontWeight: 400} : {}}>Atenção para a máxima potência monofásica ou trifásica aceita pela concessionária!</strong>
        </Typography>
        {isMobile ? (
            <InversoresListMobile 
              inversoresList={inversoresList || []}
              handleChangeInverterQuantity={handleChangeInverterQuantity}
              titulo="* Selecione a quantidade desejada de inversores"
            />
          ) : (
            <TableContainer component={Paper}>
              <Table aria-label="listagem de modulos disponíveis">
                <TableHead>
                  <TableRow>
                    <TableCell align='left'><strong>Selecione a quantidade desejada de inversores</strong></TableCell>
                    <TableCell align='center'><strong>Quantidade</strong></TableCell>
                    <TableCell align='center'><strong>Dados Técnicos</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {inversoresList.map((row) => (
                    <TableRow key={row.componente_id}>
                      <TableCell style={{ maxWidth: '400px' }} align='right' component="th">
                        <Box textAlign={'left'}>
                          <Typography className={classes.moduleTitle} variant='body1' color='textPrimary'>
                            {row.nome}
                          </Typography>
                          <Typography variant='body2' color='textSecondary'>
                            <span className={classes.warningText}>Informações</span>: {row.descricao}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell align='center' component="th">
                        <Box width="180px" margin={"0 auto"}>
                          <InputQuantidade value={row.quantidade} onChange={(v: any) => handleChangeInverterQuantity(row.componente_id, v)} />
                        </Box>
                      </TableCell>

                      <TableCell align='center' component="th">
                        <Box display={"flex"} alignItems="center" justifyContent={"center"}>
                          <IconButton
                            onClick={() => row.componente_id && modalComponentesDetalhesData$.next(row.componente_id)}
                            size="large">
                              <FindInPageOutlined htmlColor="black" />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )
        }
      </Box>
    );}, [selectedModulo, classes, handleChangeInverterQuantity, inversoresList])

    const localTiposInversoresOptions = useMemo(()=>{
      const tiposInversores = selectedModulo?.inversoresTipos || []
      if (tiposInversores.length === 1) {
        const id = tiposInversoresMap.get(tiposInversores?.[0])
        if (!id) return TIPOS_INVERSOR_OPTIONS
        return TIPOS_INVERSOR_OPTIONS.filter(item => item.value === id)
      }
      return TIPOS_INVERSOR_OPTIONS
    },[selectedModulo])

    const handleClickNext = useCallback(() => {
      onClickNext()
    },[onClickNext])

    return (
      <>
      <Layout
        formState={formState}
        nextButtonIsDisabled={nextButtonIsDisabled}
        nextButtonDisabledTooltip='Para prosseguir, selecione um módulo e preencha a quantidade de unidades desejada e posteriormente o inversor ideal para este projeto.'
        onClickBack={onClickBack}
        onClickNext={handleClickNext}
        title="Módulos e inversores"
        subtitle="Escolha o módulo e o inversor ideal para compor o gerador e atender a demanda do seu cliente."
      >
        <Box p={2}>
          {renderModulos()}

          <Box mt={5}>
            <InputComboBoxList
              id={`select-tipos-inversor`}
              key={`select-tipos-inversor`}
              label={"* Tipo de inversor"}
              textField="tipos_inversor"
              valueField="id"
              options={localTiposInversoresOptions}
              value={tipoInversor}
              autoComplete
              renderOptions={(option: any) => {
                  return `${option.text}`
              }}
              renderOptionsLabel={(option: any) => {
                  return `${option.text}`
              }}
              onChange={(value: any) => {
                const state = { ...formState }
                state.tipo_inversor = value;
                setTipoInversor(value)
                setFormState(state)
                setAlterouInversor(true)
              }}
            />
          </Box>

          {renderInversores()}
        </Box>
      </Layout>
    </>
  )
}

export { Gerador }
